module.exports = __webpack_public_path__ + "img/ignitionOff.ae252a69.svg";